import 'url-search-params-polyfill';

/**
 * getParam return some params value or null if not defined
 *
 * @export
 * @param {string} name
 * @returns {(string | null)}
 * @deprecated use qs
 */
export function getParam(name) {
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}
